import React, { useEffect, useState } from "react";
import { useCampaign } from "../../context/CampaignContext";
import bannerRoad from "../../assets/banner-road.jpg";
import logoCompleta from "../../assets/logo-completa.png";
import logoCompletaMobile from "../../assets/logo-completa-mobile.png";
import "./Hero.css";
import { Link } from "react-router-dom";

export function Hero() {
  const { campaign } = useCampaign();
  const [imagesReady, setImagesReady] = useState(false);

  useEffect(() => {
    let resolved = false;

    const resolve = () => {
      if (!resolved) {
        resolved = true;
        setImagesReady(true);
      }
    };

    const timeout = setTimeout(resolve, 2500);

    let loaded = 0;
    const total = 3;

    const checkDone = () => {
      loaded += 1;
      if (loaded >= total) resolve();
    };

    const img1 = new Image();
    img1.onload = checkDone;
    img1.onerror = checkDone;
    img1.src = logoCompletaMobile;

    const img2 = new Image();
    img2.onload = checkDone;
    img2.onerror = checkDone;
    img2.src = bannerRoad;

    const img3 = new Image();
    img3.onload = checkDone;
    img3.onerror = checkDone;
    img3.src = logoCompleta;

    return () => {
      clearTimeout(timeout);
      img1.onload = null;
      img1.onerror = null;
      img2.onload = null;
      img2.onerror = null;
      img3.onload = null;
      img3.onerror = null;
    };
  }, []);

  return (
    <section className={`hero${imagesReady ? " hero--animate" : ""}`} id="inicio">
      <div className="hero__banner">
        <div className={`hero__preloader${imagesReady ? " hero__preloader--hidden" : ""}`} aria-hidden="true">
          <div className="hero__preloader-spinner" />
        </div>
      </div>

      <img src={logoCompleta} alt="De Carona com Toro" className="hero__logo-full" aria-hidden="true" />
      <img src={logoCompletaMobile} alt="De Carona com Toro" className="hero__logo-full-mobile" aria-hidden="true" />

      <div className="hero__bottom">
        <div className="container hero__bottom-content">
          <h1 className="hero__title">
            Acelere sua carreira e garanta{" "}
            <br className="responsive-break" />
            sua Fiat Toro* na garagem!
          </h1>

          <p className="hero__description">
            Invista no seu futuro com os cursos da Academia Rafael Toro e
            concorra a um <strong>cartão de crédito de R$ 150.000,00</strong>{" "}
            para você comprar a sua Fiat Toro 0km* <em>(ou usar como quiser)</em>!
          </p>

          <div className="hero__actions">
            <a
              className="btn btn--red"
              href={campaign.purchaseUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Quero participar e concorrer!
            </a>
            {/* Ao descomentar, use <Link> do react-router-dom: */}
            <Link className="btn btn--white" to="/login">
              Consulte seus números aqui
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
